// extracted by mini-css-extract-plugin
module.exports = {"pagesLayoutBackground":"PagesList_pagesLayoutBackground__11VV-","pages-content":"PagesList_pages-content__2O4DZ","logoPreview":"PagesList_logoPreview__1RDGX"};